import { get as getAPICall } from 'aws-amplify/api';
import {
    fetchAuthSession,
    fetchUserAttributes,
    getCurrentUser,
    resendSignUpCode,
    signOut,
    updateUserAttributes
} from 'aws-amplify/auth';
import { errorHandler } from './Api';

export const isLogin = async () => {
    const {
        username,
    } = await getCurrentUser().catch((e) => {
        return false;
    });
    return username || false;
}

export const resendUserConfirmation = async (emailAddress) => {
    return await resendSignUpCode({ username: emailAddress }).catch((e) => {
        console.log("Error on the resend", e);
    });
}

export const getUserGroups = async () => {
    const {
        tokens: session
    } = await fetchAuthSession();
    const groups = session.accessToken.payload["cognito:groups"];
    return groups;
}

export const getUserDataFromId = () => {

}

const getUserDataByUserId = async (userId) => {
    const getPayload = {
        apiName: "AdminQueries",
        path: "/getUser",
        options: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${(await fetchAuthSession()).tokens.accessToken.getJwtToken()}`
            },
            queryParams: {
                "username": userId
            },
        }

    };
    const restOperation = await getAPICall(getPayload).response;
    const response = await restOperation.body.json();

    const attributes = response.UserAttributes.reduce((a, v) => {
        return {
            ...a,
            [v.Name]: v.Value
        }

    }, {});

    return {
        username: response.Username,
        attributes
    }

}

export const getUserData = async (userId = null) => {
    try {
        let currentUserData;
        if (userId) {
            currentUserData = await getUserDataByUserId(userId).catch((e) => {
                return false;
            });
        } else {
            currentUserData = await getCurrentUser();
        }

        const attributes = await fetchUserAttributes();

        let picture = "";
        if (attributes && attributes.picture) {
            try {
                const pictureData = JSON.parse(attributes.picture);
                if (pictureData.data && pictureData.data.url) {
                    picture = pictureData.data.url;
                }
            } catch (error) {
                picture = attributes.picture || "";
            }
        }

        const userdata = {
            id: currentUserData.username,
            username: currentUserData.username,
            attributes: attributes,
            picture
        }
        return userdata;
    } catch (error) {
        errorHandler(error, "No fue posible obtener el usuario logeado");
    }
    return false;
}

export const updateUserProperties = async (properties) => {
    let newProperties = {
        ...properties
    }
    delete newProperties.sub;
    delete newProperties.email_verified;
    delete newProperties.identities;

    await getCurrentUser().catch((e) => {
        return false;
    });

    return await updateUserAttributes({
        userAttributes: newProperties
    }).catch((e) => {
        console.log("Error Update user data", e);
        return false;
    });
}

export const logout = async () => {
    await signOut();
}